import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import makeStyles from "@material-ui/core/styles/makeStyles";
import FormGenerator from "../../../../../../Components/FormGenerator";
import AddToListModal from "../../../../../../Components/FormGenerator/addToListModal";
import {
  SetOrganisationContact,
  UpdateOrganisationContactError,
} from "./OrganisationContactActions";
import { useParams } from "react-router";
import DataService from "../../../../../../Service";
import { Divider, Grid } from "@material-ui/core";

// const theme = createMuiTheme({
//   overrides: {
//     MuiFormControl: {
//       root: {
//         width: "100%",
//       },
//     },
//   },
// });

export default function Contact(props) {
  const dispatch = useDispatch();
  const params = useParams();

  // const [countyList, setCountyList] = useState([]);
  // const [cityList, setCityList] = useState([]);
  const [showAddNewModal, setShowAddNewModal] = useState(false);
  const [showAddNewModalExist, setShowAddNewModalExist] = useState(false);
  const [addNewModalProps, setAddNewModalProps] = useState({});

  const {
    website,
    primary_telephone,
    primary_fax,
    primary_email,
    facebook,
    twitter,
    linkedin,
    parent_organisation,
    departments,
    business_units,
    offices,
    functions,
    organisation_branches,
    panel,
    magic20_fields,
  } = useSelector((state) => state.organisationContactReducer.data);
  // const reducerData = useSelector((state) => state.organisationContactReducer.data);
  console.log("orgMagic", magic20_fields);
  const {
    // department_lists,
    // business_unit_lists,
    // office_lists,
    // function_lists,
    country_lists,
    parent_organisations,
    magic20_fields: magic20_fields_options,
  } = useSelector((state) => state.commonReducer.organisationDropdowns);
  console.log("magic", magic20_fields);
  const errors = useSelector(
    (state) => state.organisationContactReducer.errors
  );
  // const [bu_attribute, setBu_attribute] = useState([]);
  // useEffect(() => {
  //    // option.itemArr.length = 0;
  //    var funcdata = [...function_lists, { id: function_lists.length + 1, value: "Add New" }];
  //    setBu_attribute(funcdata)
  // }, [function_lists]);

  // useEffect(() => {
  //   function_lists.push({ id: function_lists.length + 1, value: "Add New",label:"Add New" })
  //   business_unit_lists.push({ id: business_unit_lists.length + 1, value: "Add New",label:"Add New" })
  //   department_lists.push({ id: department_lists.length + 1, value: "Add New",label:"Add New" })
  //   // var pdata = [...response[mappedKeyJSON.Role], { id: response[mappedKeyJSON.Role] + 1, value: "Add New" }];
  // }, [])
  // const handleCountyList = (value) => {

  //   DataService.getData({ country: value }, 'listing_county').then((res) => {
  //     const county_list = res.states.map((item, index) => ({ value: item, id: item }));
  //     setCountyList(county_list);
  //   })

  // }
  // const handleCityList = (country, county) => {

  //   DataService.getData({ country: country, state: county }, 'listing_cities').then((res) => {
  //     const city_list = res.cities.map((item, index) => ({ value: item, id: item }));
  //     setCityList(city_list);
  //   })
  // }
  const addNewHandler = (
    addNewModalExistFlag,
    modalFlag,
    addNewModalPropsData
  ) => {
    setShowAddNewModalExist(addNewModalExistFlag);
    setShowAddNewModal(modalFlag);
    setAddNewModalProps({ ...addNewModalProps, ...addNewModalPropsData });
  };
  const handleInputChange = (value, index, key) => {
    props.setSomeChangeDetected(true);
    // console.log("index", index, "key", key)
    const updatedForm = formInput;
    console.log("updatedForm", formInput);
    if (updatedForm[index]["name"] === "magic20_fields") {
      let oldValue = { ...magic20_fields };
      if (value?.length > Object.keys(oldValue).length) {
        oldValue[value.at(-1)] = [];
        updatedForm[index]["value"] = oldValue ?? "";
      } else {
        if (!value?.length) {
          oldValue = {};
        } else {
          Object.keys(oldValue).map((item) => {
            if (!value.includes(item)) {
              delete oldValue[item];
            }
          });
        }
        updatedForm[index]["value"] = oldValue ?? "";
      }
      const formData = {};
      setFormInput(updatedForm);
      formInput.forEach((item, fIndex) => {
        if (fIndex === index) {
          formData[item.name] = item.value ?? "";
        }
      });
      dispatch(SetOrganisationContact(formData));
      if (updatedForm[index].name !== "organisation_branches") {
        dispatch(UpdateOrganisationContactError(updatedForm[index].name));
      }
    } else {
      let keyIndex = index;
      if (key) {
        keyIndex = formInput.findIndex((item) => item.name === key);
      }
      updatedForm[keyIndex]["value"] = value ?? "";
      const formData = {};
      setFormInput(updatedForm);
      console.log("formInput", formInput);
      formInput.forEach((item, fIndex) => {
        formData[item.name] = item.value ?? "";
        if (fIndex === keyIndex) {
          formData[item.name] = item.value ?? "";
          console.log("formData", formData);
          dispatch(SetOrganisationContact(formData));
        }
      });
      if (updatedForm[keyIndex].name !== "organisation_branches") {
        dispatch(UpdateOrganisationContactError(updatedForm[keyIndex].name));
      }
    }
  };

  const [addressObject, setAddressObject] = useState(
    params.id && organisation_branches.length > 0
      ? organisation_branches[0]
      : {}
  );
  const handleAddressChange = (value, index) => {
    // if(index.split("-")[1] === 'country_list_id'){
    //   handleCityList(value);
    // }
    const arrayIndex = index.split("-")[0];
    const itemName = index.split("-")[1];
    const updatedAddress = addressObject;
    updatedAddress[itemName] = value;
    setAddressObject(updatedAddress);
    handleInputChange([addressObject], Number(arrayIndex));
    dispatch(UpdateOrganisationContactError(itemName));
  };

  const formArray = [
    {
      componentType: "input",
      type: "text",
      label: "Website*",
      name: "website",
      placeholder: "www.organisation.com",
      helperText: errors.website && "Please enter a website url",
      handleChange: handleInputChange,
      value: website,
    },
    {
      componentType: "address",
      name: "organisation_branches",
      hqAddress: {
        placeholder: "HQ address",
        label: "HQ address",
        multiline: true,
        type: "text",
        name: "hq_address",
        index: "1-hq_address",
        handleChange: handleAddressChange,
        helperText: errors.hq_address && "Please enter HQ Address",
        value:
          organisation_branches.length > 0
            ? organisation_branches[0].hq_address
            : "",
      },
      businessAddress: {
        placeholder: "Business address",
        type: "text",
        label: "Business address",
        name: "business_address",
        index: "1-business_address",
        handleChange: handleAddressChange,
        helperText: errors.business_address && "Please enter Business address",
        value:
          organisation_branches.length > 0
            ? organisation_branches[0].business_address
            : "",
      },

      addressLine1: {
        placeholder: "Business address line1",
        type: "text",
        name: "address_line1",
        index: "1-address_line1",
        handleChange: handleAddressChange,
        helperText: errors.address_line1 && "Please enter HQ address",
        value:
          organisation_branches.length > 0
            ? organisation_branches[0].address_line1
            : "",
      },
      addressLine2: {
        placeholder: "Business address line2",
        type: "text",
        name: "address_line2",
        index: "1-address_line2",
        handleChange: handleAddressChange,
        value:
          organisation_branches.length > 0
            ? organisation_branches[0].address_line2
            : "",
      },
      city: {
        name: "city",
        otherName: "addressCity",
        // index: "1-city",
        // handleChange: handleAddressChange,
        placeholder: "Business city/town",
        // apiVariable: "source_referral1",
        index: "1-city",
        label: "Business city",
        handleChange: handleAddressChange,
        value:
          organisation_branches.length > 0 ? organisation_branches[0].city : "",
        helperText: errors.city && "Please enter Business city/town",
        // apiVariable: "listing_cities",
        // params: { country: branches[0].county },
        // country_value: branches[0].county
      },
      country: {
        // componentType: "select",
        name: "country_list_id",
        // value: source_referral1_id,
        placeholder: "Business country",
        select: true,
        defaultValue: "Country",
        label: "Business country",
        // apiVariable: "countries",
        selectOptions: country_lists,
        index: "1-country_list_id",
        handleChange: handleAddressChange,
        value:
          organisation_branches.length > 0
            ? organisation_branches[0].country_list_id
            : "",
        helperText: errors.country_list_id && "Please select a country",
      },
      county: {
        name: "county",
        type: "text",
        placeholder: "Business county/state/region",
        label: "Business county/state/region",
        // apiVariable: "countries",
        index: "1-county",
        handleChange: handleAddressChange,
        value:
          organisation_branches.length > 0
            ? organisation_branches[0].county
            : "",
        helperText:
          errors.county && "Please enter a Business county/state/region",
      },
      businessTelephone: {
        placeholder: "Business telephone",
        type: "number",
        label: "Business telephone",
        name: "business_telephone",
        index: "1-business_telephone",
        handleChange: handleAddressChange,
        value:
          organisation_branches.length > 0
            ? organisation_branches[0].business_telephone
            : "",
        helperText:
          errors.business_telephone && "Please enter a business telephone",
      },
      businessFax: {
        placeholder: "Business fax",
        type: "text",
        label: "Business fax",
        name: "business_fax",
        index: "1-business_fax",
        handleChange: handleAddressChange,
        value:
          organisation_branches.length > 0
            ? organisation_branches[0].business_fax
            : "",
      },
      businessEmail: {
        placeholder: "Business email",
        type: "text",
        label: "Business email",
        name: "business_email",
        index: "1-business_email",
        handleChange: handleAddressChange,
        value:
          organisation_branches.length > 0
            ? organisation_branches[0].business_email
            : "",
        helperText: errors.business_email && "Please enter a valid email",
      },
      zipcode: {
        name: "zipcode",
        type: "text",
        placeholder: "Business post/zip code",
        index: "1-zipcode",
        label: "Business post/zip code",
        handleChange: handleAddressChange,
        value:
          organisation_branches.length > 0
            ? organisation_branches[0].zipcode
            : "",
        helperText: errors.postcode && "Please enter a zipcode",
      },
      label: "Business address",
      // Address component to go here
    },
    {
      componentType: "input",
      type: "text",
      label: "Primary email",
      name: "primary_email",
      // required: true,
      placeholder: "Primary email",
      handleChange: handleInputChange,
      helperText: errors.primary_email && "Please enter a valid email",
      value: primary_email,
    },
    {
      componentType: "phone",
      type: "number",
      label: "Primary telephone",
      name: "primary_telephone",
      placeholder: "Primary telephone",
      handleChange: handleInputChange,
      value: primary_telephone,
    },
    {
      componentType: "input",
      type: "text",
      label: "Facebook",
      name: "facebook",
      placeholder: "facebook.com/company/organisation",
      handleChange: handleInputChange,
      value: facebook,
    },
    {
      componentType: "input",
      type: "text",
      label: "LinkedIn",
      name: "linkedin",
      placeholder: "linkedin.com/company/organisation",
      handleChange: handleInputChange,
      value: linkedin,
    },
    {
      componentType: "input",
      type: "text",
      label: "Twitter",
      name: "twitter",
      placeholder: "twitter.com/organisation",
      handleChange: handleInputChange,
      value: twitter,
    },
    {
      componentType: "input",
      label: "Parent organization",
      name: "parent_organisation",
      placeholder: "Parent organization",
      handleChange: handleInputChange,
      value: parent_organisation,
      multiline: true,
    },
    {
      componentType: "multiSelectChip",
      label: "Terminology used for Departments/Business units etc.",
      name: "magic20_fields",
      itemArr: magic20_fields_options,
      id: "magic20_fields",
      placeholder: "Select terminology used for Departments/Business units",
      value: Object.keys(magic20_fields || {}),
      selectOptions: magic20_fields_options,
      dropDown: "Magic20",
      field_name: "name",
      handleChange: handleInputChange,
    },
    {
      componentType: "rederComponent",
      value: magic20_fields,
      component: (
        <IncomePerYearComponent
          handleChange={handleInputChange}
          value={magic20_fields}
        />
      ),
    },
  ];

  const [formInput, setFormInput] = useState(formArray);

  useEffect(() => {
    setFormInput(formArray);
  }, [errors, magic20_fields_options]);
  // const country = organisation_branches[0].country_list_id;
  // useMemo(() => handleCountyList(country), [country]);
  // const countyName = organisation_branches[0].county;
  // useMemo(() =>  handleCityList(country,countyName), [countyName]);
  // const country = organisation_branches[0].country_list_id;
  // useMemo(() => handleCityList(country), [country]);

  return (
    <>
      <FormGenerator
        children={formInput}
        nextIndex={3}
        setId={props.setId}
        moduleName="organization"
      />
      {showAddNewModalExist && showAddNewModal && (
        <AddToListModal
          type="partner_profiles"
          postData={{ ...addNewModalProps }}
        />
      )}
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      display: "flex",
    },
  },
  gridRoot: {
    flexGrow: 1,
    marginBottom: "20px",
  },
  helperText: {
    color: "red",
  },
  disabled: {
    background: "#f5f2f2",
  },

  textInput: {
    "& input::placeholder": {
      color: "#808080",
      opacity: 1,
    },
  },
}));

const IncomePerYearComponent = (props) => {
  const classes = useStyles();
  const { handleChange } = props;

  const { magic20_fields } = useSelector(
    (state) => state.organisationContactReducer.data
  );
  console.log("fieldsData", magic20_fields);
  const { magic20_fields: magic20_fields_options } = useSelector(
    (state) => state.commonReducer.organisationDropdowns
  );

  const handleInputChange = useCallback(
    (value, index, type, dynamicField) => {
      console.log(
        "value, index, type, dynamicField",
        value,
        index,
        type,
        dynamicField
      );
      const oldValue = { ...magic20_fields };
      console.log("oldValue", oldValue);
      oldValue[Object.keys(magic20_fields || {})[index]] = value?.length
        ? value
        : [];
      handleChange(oldValue, 0, "magic20_fields");
    },
    [magic20_fields]
  );

  let formField = [];
  magic20_fields &&
    Object.keys(magic20_fields)?.length &&
    Object.keys(magic20_fields).forEach((item) => {
      const options = magic20_fields_options?.find(
        (fieldItem) => fieldItem.id === item
      );
      formField.push({
        componentType: "multiSelectChip",
        label: item,
        name: `${item}`,
        itemArr: options?.magic20_associates ? options?.magic20_associates : [],
        id: `${item}`,
        placeholder: `Select ${item}`,
        value:
          magic20_fields && magic20_fields[item] ? magic20_fields[item] : [],
        selectOptions: options?.magic20_associates
          ? options?.magic20_associates
          : [],
        dropDown: "Magic20Associate",
        field_name: "field_name",
        growingAdionalParam: { magic20_field_id: options?.magic20_field_id },
        handleChange: handleInputChange,
      });
    });
  const [formInput1, setFormInput1] = useState(formField);

  useEffect(() => {
    setFormInput1(formField);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [magic20_fields_options]);
  return (
    <Grid container className={classes.gridRoot}>
      <Grid item xs={12} md={4}></Grid>
      <Grid item xs={12} md={7}>
        <FormGenerator
          children={formField}
          nextIndex={3}
          setId={props.setId}
          moduleName="organization"
          style={
            {
              // width: "100%",
            }
          }
        />
      </Grid>
    </Grid>
  );
};
